import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookie from 'vue-cookies';
import axios from 'axios'

const home = () => import(`@/components/home.vue`)
const reportExport = () => import(`@/components/export.vue`)
const authLayout = () => import(`@/components/auth/index.vue`)
const login = () => import(`@/components/auth/login.vue`)
const registry = () => import(`@/components/auth/registry.vue`)
const callback = () => import(`@/components/auth/callback.vue`)
const page404 = () => import(`@/components/page404.vue`)
const account_approval = () => import(`@/components/auth/account_approval.vue`)

const layout = () => import(`@/components/permission_manage/layout.vue`)
const roles = () => import(`@/components/permission_manage/newroles.vue`)
const perms = () => import(`@/components/permission_manage/perms.vue`)
const groups = () => import(`@/components/permission_manage/newElTreeGroup.vue`)
const users = () => import(`@/components/permission_manage/users.vue`)
const approval_process = () => import(`@/components/permission_manage/approval_process.vue`)
const accountAdd = () => import(`@/components/permission_manage/accountAdd.vue`)

const allusers = () => import(`@/components/app_manage/allusers.vue`)
const app = () => import(`@/components/app_manage/app.vue`)
const layout_new = () => import(`@/components/app_manage/layout_new.vue`)

const personal_center = () => import(`@/components/personal_center/personal_center.vue`)
const my_groups = () => import(`@/components/personal_center/my_groups.vue`)
const my_groups_perms = () => import(`@/components/personal_center/my_group_perms.vue`)
const my_tokens = () => import(`@/components/personal_center/my_tokens.vue`)
const my_password = () => import(`@/components/personal_center/my_password.vue`)
const personal_information = () => import(`@/components/personal_center/personal_information.vue`)
const decathlon_callback = () => import(`@/components/auth/decathlon_callback.vue`)
const error_page = () => import(`@/components/auth/error_page.vue`)

Vue.use(VueRouter)

const router = new VueRouter({
  routes : [
  { name: 'layout',
    path: '/manager/account/:app_code?',
    component: layout,
    meta: { requiresAuth: true },
    children: [
      { name: 'perms', path: 'perms/', component: perms, meta: { requiresAuth: true }},
      { name: 'groups', path: 'groups/', component: groups, meta: { requiresAuth: true }},
      { name: 'roles', path: 'roles/', component: roles, meta: { requiresAuth: true }},
      { name: 'users', path: 'users/', component: users, meta: { requiresAuth: true }},
      { name: 'approval_process', path: 'approval_process/', component: approval_process, meta: {requiresAuth: true}},
    ]
  },
  { name: 'accountAdd', path: '/account_add/', component: accountAdd, meta: {requiresAuth: true}},
  { name: 'decathlon_callback', path: '/middle/', component: decathlon_callback},
  { name: 'error_page', path: '/error_page', component: error_page},
  { name: 'auth',
    path: '/auth',
    component: authLayout,
    redirect: '/auth/login',
    children: [
      { name: 'login', path: 'login/:app_code?', component: login},
      { name: 'registry', path: 'registry', component: registry },
      { name: 'callback', path: 'callback', component: callback },
      { name: 'account_approval', path: 'account_approval', component: account_approval}
    ]
  },
    {
    name: 'account',
    path:'/account',
    component:layout_new,
    meta: { requiresAuth: true },
    children: [
    { name: 'app', path: 'app', component: app, meta: { requiresAuth: true }},
    { name: 'allusers', path: 'allusers', component: allusers, meta: { requiresAuth: true }}
    ]
    },
    {
      name: 'personal_center',
      path: '/personal/center/:app_code?',
      meta: {requiresAuth: true},
      component: personal_center,
      children: [
        { name: 'my_groups', path: 'my_groups/', component: my_groups, meta: { requiresAuth: true }},
        { name: 'my_groups_perms', path: 'my_groups_perms/', component: my_groups_perms, meta: { requiresAuth: true }},
        { name: 'my_tokens', path: 'my_tokens', component: my_tokens, meta: { requiresAuth: true }},
        { name: 'my_password', path: 'my_password', component: my_password, meta: { requiresAuth: true }},
        { name: 'personal_information', path: 'personal_information', component: personal_information, meta: { requiresAuth: true }}

      ]
    },
    {
      path: '/',
      redirect: '/auth/login',
    },
  { path: '*', component: page404 }

],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    let token = localStorage.getItem('token')
    if (!token) {
      next({
        path: '/auth/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // 确保一定要调用 next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js